import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import EcacArrivalSummaryReportService from '_services/ecac-arrival-summary-report-service';

export const fetchEcacArrivalSummaryReport = createAsyncThunk(
    'ecacArrivalSummaryReport/fetch',
    async (params, { signal }) => {
        return await EcacArrivalSummaryReportService.getEcacArrivalSummaryReport(params, signal);
    }
);

export const patchBookings = createAsyncThunk(
    'ecacArrivalSummaryReport/patchBookings',
    async ({ bookingIds, patch }) => {
        await Promise.all(
            bookingIds.map((bookingId) => EcacArrivalSummaryReportService.patchBooking(bookingId, patch))
        );
        return { bookingIds, patch };
    }
);

const initialState = {
    data: null,
    status: 'idle',
    error: null,
    patchStatus: 'idle',
    patchError: null,
};

const ecacArrivalSummaryReportSlice = createSlice({
    name: 'ecacArrivalSummaryReport',
    initialState,
    reducers: {
        resetEcacArrivalSummaryReport: (state) => {
            state.data = null;
            state.status = 'idle';
            state.error = null;
        },
        resetPatchBookingStatus: (state) => {
            state.patchStatus = 'idle';
            state.patchError = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEcacArrivalSummaryReport.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchEcacArrivalSummaryReport.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
                state.error = null;
            })
            .addCase(fetchEcacArrivalSummaryReport.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            .addCase(patchBookings.pending, (state) => {
                state.patchStatus = 'loading';
                state.patchError = null;
            })
            .addCase(patchBookings.fulfilled, (state) => {
                state.patchStatus = 'succeeded';
                state.patchError = null;
            })
            .addCase(patchBookings.rejected, (state, action) => {
                state.patchStatus = 'failed';
                state.patchError = action.error.message;
            });
    },
});

export const selectEcacArrivalSummaryReportData = (state) => state.ecacArrivalSummaryReport.data;
export const selectEcacArrivalSummaryReportStatus = (state) => state.ecacArrivalSummaryReport.status;
export const selectEcacArrivalSummaryReportError = (state) => state.ecacArrivalSummaryReport.error;
export const selectPatchBookingStatus = (state) => state.ecacArrivalSummaryReport.patchStatus;

export const { resetEcacArrivalSummaryReport, resetPatchBookingStatus } = ecacArrivalSummaryReportSlice.actions;

export default ecacArrivalSummaryReportSlice.reducer;
